// SVG viewBox: 0 0 300 120 — x: year 2025→2075 mapped to 0→300, y: income $0→$200K mapped to 120→0
const LINE_POINTS: [number, number][] = [
	[0, 117],
	[30, 115],
	[60, 112],
	[90, 106],
	[120, 96],
	[150, 81],
	[180, 63],
	[210, 42],
	[240, 27],
	[270, 18],
	[300, 12],
]

const linePath = LINE_POINTS.map(([x, y], i) => `${i === 0 ? "M" : "L"} ${x} ${y}`).join(" ")
const areaPath = `${linePath} L 300 120 L 0 120 Z`
const GOAL_Y = 72 // ~$80K/yr goal

export function ProjectionMockup() {
	return (
		<div className="rounded-2xl overflow-hidden border border-white/40 dark:border-sky-100/10 bg-white/80 dark:bg-sky-950/80 backdrop-blur-md shadow-2xl">
			{/* Browser chrome */}
			<div className="flex items-center gap-1.5 px-3 py-2.5 bg-sky-50/80 dark:bg-sky-900/40 border-b border-sky-100/60 dark:border-sky-800/30">
				<div className="w-2 h-2 rounded-full bg-red-400/70" />
				<div className="w-2 h-2 rounded-full bg-amber-400/70" />
				<div className="w-2 h-2 rounded-full bg-green-400/70" />
				<div className="ml-auto text-[9px] font-bold text-sky-700 dark:text-sky-300">BeeDiv</div>
			</div>

			<div className="p-3 space-y-2">
				{/* Header row */}
				<div className="flex items-start justify-between">
					<div>
						<div className="text-xs font-bold text-sky-900 dark:text-sky-100">FIRE Projection</div>
						<div className="text-[9px] text-sky-500/70 dark:text-sky-400/60">50-year dividend income</div>
					</div>
					<div className="bg-green-100/80 dark:bg-green-900/30 border border-green-200/60 dark:border-green-800/30 rounded-lg px-2 py-1 text-center">
						<div className="text-[8px] text-green-700/70 dark:text-green-400/60">Freedom in</div>
						<div className="text-xs font-bold text-green-700 dark:text-green-400">18 yrs</div>
					</div>
				</div>

				{/* Chart */}
				<div className="flex gap-1">
					{/* Y-axis labels */}
					<div className="flex flex-col justify-between py-0.5 pr-1">
						{["$200K", "$150K", "$100K", "$50K", "$0"].map((l) => (
							<span
								key={l}
								className="text-[7px] text-sky-500/50 dark:text-sky-400/40 leading-none text-right"
							>
								{l}
							</span>
						))}
					</div>

					{/* SVG chart */}
					<div className="flex-1">
						<svg viewBox="0 0 300 120" className="w-full" preserveAspectRatio="none">
							<defs>
								<linearGradient id="projGrad" x1="0" y1="0" x2="0" y2="1">
									<stop offset="0%" stopColor="#0ea5e9" stopOpacity="0.45" />
									<stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.03" />
								</linearGradient>
							</defs>

							{/* Horizontal grid lines */}
							{[30, 60, 90].map((y) => (
								<line
									key={y}
									x1="0"
									y1={y}
									x2="300"
									y2={y}
									stroke="currentColor"
									strokeWidth="0.4"
									opacity="0.12"
								/>
							))}

							{/* Area fill */}
							<path d={areaPath} fill="url(#projGrad)" />

							{/* Income line */}
							<path d={linePath} fill="none" stroke="#0ea5e9" strokeWidth="1.5" />

							{/* Goal line */}
							<line
								x1="0"
								y1={GOAL_Y}
								x2="300"
								y2={GOAL_Y}
								stroke="#22c55e"
								strokeWidth="1"
								strokeDasharray="5,3"
							/>
							<text x="3" y={GOAL_Y - 3} fill="#22c55e" fontSize="7" opacity="0.9">
								Goal
							</text>

							{/* Freedom crossover dot */}
							<circle cx="165" cy={GOAL_Y} r="3" fill="#22c55e" opacity="0.9" />
						</svg>

						{/* X-axis labels */}
						<div className="flex justify-between mt-0.5">
							{["2025", "2037", "2050", "2062", "2075"].map((y) => (
								<span key={y} className="text-[7px] text-sky-500/50 dark:text-sky-400/40">
									{y}
								</span>
							))}
						</div>
					</div>
				</div>

				{/* Legend */}
				<div className="flex gap-4 pt-0.5">
					<div className="flex items-center gap-1.5">
						<div className="w-4 h-0.5 bg-sky-500 rounded" />
						<span className="text-[8px] text-sky-600/60 dark:text-sky-400/50">Projected Income</span>
					</div>
					<div className="flex items-center gap-1.5">
						<svg width="16" height="2" viewBox="0 0 16 2">
							<line
								x1="0"
								y1="1"
								x2="16"
								y2="1"
								stroke="#22c55e"
								strokeWidth="1.5"
								strokeDasharray="4,2"
							/>
						</svg>
						<span className="text-[8px] text-sky-600/60 dark:text-sky-400/50">Income Goal</span>
					</div>
				</div>
			</div>
		</div>
	)
}
